export default __webpack_public_path__ + "static/media/logo.410ab5b7.png";